import { useQuery } from '@tanstack/react-query';
import type { ApprovalRequestRevisionRef } from '../api/approvalRequests';
import { contentApi } from '../api/content';

/**
 * DM-7214: the stored revision an approval request points at, with the live
 * item it would replace. A gone revision is an answer, not an outage, so it
 * is not retried.
 */
export function useContentRevision(ref: ApprovalRequestRevisionRef | undefined) {
  return useQuery({
    queryKey: ['contentRevision', ref?.content_id ?? '', ref?.revision_id ?? ''],
    queryFn: () => contentApi.getRevision(ref?.content_id ?? '', ref?.revision_id ?? ''),
    enabled: ref !== undefined,
    retry: false,
  });
}
